import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getInitialPageId, getLayoutAssetUrl } from 'editor-utils/template';
import generateDummyData, { generateDummyFontData } from '../../generator/generateDummyData';
import useEditorItemContext from '../../context/editorItemContext';

import DesignSelect from '../components/designSelect';
import EditorLayout from '../components/layout';
import { Button, Typography } from '../../components/base';

const TestSource = props => {
  const { item, template } = useEditorItemContext();

  const [initialPageId, setInitialPageId] = useState(getInitialPageId(template, item.pages));

  const isPreviewEnabled = item.photos.length >= 0;

  const handleOnPreviewClick = async e => {
    e.preventDefault();

    props.onSuccess(() => generateDummyData(template, initialPageId));
  };
  const sideToolbars = [];

  if (template.pages.length > 1) {
    sideToolbars.push(
      <DesignSelect
        key="design_page"
        title="PICK A DESIGN"
        active={initialPageId}
        onChange={setInitialPageId}
        items={template.pages.map(page => ({
          key: page.id,
          title: `${page.caption} - ${page.group}`,
          icon: getLayoutAssetUrl(template, page.id, {
            media: '@2x',
            suffix: initialPageId === page.id && '-active',
          }),
        }))}
        className="mb-3"
      />,
    );
  }

  return (
    <EditorLayout
      actionButton={
        <Button disabled={!isPreviewEnabled} variant="primary" onClick={handleOnPreviewClick}>
          Preview
        </Button>
      }
      toolbars={sideToolbars}
      primaryChildren={props.children}
    >
      <Typography.Heading size={1}>
        TEST PDF GENERATOR. Only click to Preview, photos and texts are generated dynamically.
      </Typography.Heading>
    </EditorLayout>
  );
};

TestSource.propTypes = {
  onSuccess: PropTypes.func,
  children: PropTypes.node,
};

export default TestSource;
